import { useCallback } from 'react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

export const useMoveFormTableRow = (
  form: {
    getValues: UseFormGetValues<any>;
    setValue: UseFormSetValue<any>;
  },
  sequenceNumberFieldName = 'sequenceNumber'
) => {
  const { getValues, setValue } = form;

  return useCallback(
    (fieldName: string, fromIndex: number, toIndex: number) => {
      const rows = getValues(fieldName) as any[];

      setValue(
        fieldName,
        fromIndex < toIndex
          ? [
              ...rows.slice(0, fromIndex),
              ...updateSequenceNumbers(
                fromIndex + 1,
                [...rows.slice(fromIndex + 1, toIndex + 1), rows[fromIndex]],
                sequenceNumberFieldName
              ),
              ...rows.slice(toIndex + 1),
            ]
          : [
              ...rows.slice(0, toIndex),
              ...updateSequenceNumbers(
                toIndex + 1,
                [rows[fromIndex], ...rows.slice(toIndex, fromIndex)],
                sequenceNumberFieldName
              ),
              ...rows.slice(fromIndex + 1),
            ],
        { shouldDirty: true }
      );
    },
    [getValues, setValue]
  );
};

export const updateSequenceNumbers = (
  startValue: number,
  array: any[],
  fieldName = 'sequenceNumber'
) =>
  array.map((item, index) => ({
    ...item,
    [fieldName]: startValue + index,
  }));
